import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "text-muted" }

import { toRef } from 'vue'

    import type { AttributeDataReadModel } from '@Alternatives/Alternatives/Domain/readmodels'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AttributeDataView',
  props: {
    readModel: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- shortcuts ----------------

    const rm = toRef(props, 'readModel')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("strong", null, _toDisplayString(rm.value.Title), 1 /* TEXT */),
    _createElementVNode("div", null, [
      (rm.value.HasValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (rm.value.HasMultipleValues)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.ValuesAsArray, (v) => {
                      return (_openBlock(), _createElementBlock("li", null, _toDisplayString(v), 1 /* TEXT */))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("span", null, _toDisplayString(rm.value.Value), 1 /* TEXT */)
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "text-muted font-italic" }, "Not provided", -1 /* CACHED */)
          ]))]))
    ]),
    _createElementVNode("small", _hoisted_5, _toDisplayString(rm.value.Description), 1 /* TEXT */)
  ]))
}
}

})